<!-- display-mobile-18 preview — a full-screen text interstitial: the advertiser
     mark at the top, then an oversized headline, the advertiser name and the
     description, and a dismiss/action pair riding the bottom of the screen.
     There is no publisher page behind it and no creative in it, so this variant
     shares none of the page/skeleton/browser-bar styles the in-article
     placements use. -->
<app-mobile-frame>
  <!-- START: Interstitial -->
  <div class="da-interstitial d-flex flex-column">
    <!-- GenSingleImagePreviewData carries no advertiser field, so the mark and
         the name below it are literals, the same compromise the other
         placements make. -->
    <img *ngIf="data.logo" class="da-logo" [src]="data.logo" alt="" />
    <span *ngIf="!data.logo" class="da-logo logo-empty" aria-hidden="true"></span>

    <!-- The copy sits in a narrower measure than the buttons below it; see the
         stylesheet for how the mock's line breaks pin that width down. -->
    <div class="da-copy">
      <a [href]="data.url" target="_blank" rel="noopener noreferrer" class="da-headline">
        {{ data.headlines[0] || "Your headline appears here" }}
      </a>

      <div class="da-advertiser">Valamar</div>

      <div class="da-desc">
        {{ data.descriptions[0] || "Your description appears here" }}
      </div>
    </div>

    <div class="da-actions d-flex flex-row">
      <!-- The interstitial's dismiss control. It is ad chrome rather than
           authored copy, so it is a literal — there is no field for it on the
           template. -->
      <span class="da-close d-flex align-items-center justify-content-center">
        <span class="da-label">Close</span>
      </span>

      <a
        [href]="data.url" target="_blank" rel="noopener noreferrer"
        class="da-cta d-flex align-items-center justify-content-center"
      >
        <span class="da-label">{{ data.ctaText || "Your call to action" }}</span>
      </a>
    </div>

    <!-- Chrome the network draws over the unit, so it is decorative here. It
         needs no white tile of its own in this placement: there is no creative
         for it to sit on. -->
    <span
      class="da-adchoices d-flex align-items-center justify-content-center"
      aria-hidden="true"
    >
      <i class="bi bi-info-circle"></i>
    </span>
  </div>
  <!-- END: Interstitial -->
</app-mobile-frame>
